import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  padding: 0.75rem 1.25rem;
  margin: 1rem 0;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  font-size: 14px;
  &.danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }
  &.success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }
  &.warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }
`;

export const MessageList = styled.ul`
  margin-left: 15px;
  li {
    text-align: left;
    margin-top: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Messages/style.js